module.exports = __webpack_public_path__ + "media/ppp/subscribe_button/icon-newsletter-d6bfb1465afb996ab10664d6d8a6667f.svg";